import {
  computeDaysAfterFiscalDeadline,
  resolveLateInterestsAmount,
} from '@Common/types/bo/b2b/campaigns/late_interests';
import { B2bCampaignActionHandler } from '@Common/types/bo/b2b/contracts';
import { makeIntegerAmount } from '@Common/types/currency/currency';

type LatePaymentInterestsFormValues = {
  is_automatic_late_payment_interests?: 'yes' | 'no';
  late_payment_interests_override_amount?: number | null;
  end_date?: Date | string | null;
  fiscal_period_start: Date | string;
  fiscal_period_end: Date | string;
  type: string;
};

export function getLatePaymentInterestsAmount({
  formValues,
  totalAllocatedAmount,
  choiceCollectedBy,
  tmoPct,
}: {
  formValues: LatePaymentInterestsFormValues;
  totalAllocatedAmount: number;
  choiceCollectedBy: B2bCampaignActionHandler | null;
  tmoPct: number | null;
}): number {
  return resolveLateInterestsAmount({
    amount: makeIntegerAmount(totalAllocatedAmount),
    daysAfterFiscalDeadline: computeDaysAfterFiscalDeadline({
      endDate: new Date(formValues.end_date ?? new Date()),
      fiscalPeriodStart: new Date(formValues.fiscal_period_start),
      fiscalPeriodEnd: new Date(formValues.fiscal_period_end),
      campaignType: formValues.type,
      choiceCollectedBy,
    }),
    tmoPct,
    isAutomatic: formValues.is_automatic_late_payment_interests === 'yes',
    overrideAmount: formValues.late_payment_interests_override_amount,
  });
}
